/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router';

import PermissionDenied from '../pages/denied';
import Login from '../pages/login';
import RequireAuth from './RequireAuth';
import ErrorBoundary from '../components/errorBoundary';
import Loader from '../components/loader-component';

// Lazy-loaded heavy pages — only fetched when route is accessed
const Dashboard = lazy(() => import('../pages/dashboard'));
const Admin = lazy(() => import('../pages/admin'));

const LazyFallback = () => <Loader />;

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path='/' element={<Login />} />
      <Route path='/app' element={<RequireAuth />}>
        <Route
          path='/app/admin'
          element={
            <ErrorBoundary>
              <Suspense fallback={<LazyFallback />}>
                <Admin />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/app/dashboard'
          element={
            <ErrorBoundary>
              <Suspense fallback={<LazyFallback />}>
                <Dashboard />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='/app/dashboard/:name'
          element={
            <ErrorBoundary>
              <Suspense fallback={<LazyFallback />}>
                <Dashboard />
              </Suspense>
            </ErrorBoundary>
          }
        />
        <Route
          path='*'
          element={
            <>
              <h1>404 page</h1>
            </>
          }
        />
      </Route>
      <Route path='/permission-denied' element={<PermissionDenied />} />
      <Route
        path='*'
        element={
          <>
            <h1>404 page</h1>
          </>
        }
      />
    </>
  )
);
